import { BookmarkCheck, X } from "lucide-react";
import type { SourceDocument } from "../lib/documentSearch/types";

type PinnedSourcesTrayProps = {
  pinnedSources: SourceDocument[];
  onSelect: (documentId: string) => void;
  onUnpin: (documentId: string) => void;
};

export function PinnedSourcesTray({
  pinnedSources,
  onSelect,
  onUnpin,
}: PinnedSourcesTrayProps) {
  return (
    <section className="pinned-tray" aria-label="Pinned sources">
      <div className="pinned-tray__header">
        <BookmarkCheck size={17} aria-hidden="true" />
        <h2>Pinned sources</h2>
        <span>{pinnedSources.length}</span>
      </div>
      {pinnedSources.length === 0 ? (
        <p className="pinned-tray__empty">No sources pinned yet.</p>
      ) : (
        <div className="pinned-tray__items">
          {pinnedSources.map((document) => (
            <div className="pinned-source" key={document.id}>
              <button type="button" onClick={() => onSelect(document.id)}>
                <strong>{document.title}</strong>
                <span>
                  {document.type} · {document.year}
                </span>
              </button>
              <button
                className="pinned-source__remove"
                type="button"
                onClick={() => onUnpin(document.id)}
                aria-label={`Unpin ${document.title}`}
              >
                <X size={15} aria-hidden="true" />
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
